import { render } from "./PostNowhuo.vue?vue&type=template&id=faab0d6c&scoped=true"
import script from "./PostNowhuo.vue?vue&type=script&lang=js"
export * from "./PostNowhuo.vue?vue&type=script&lang=js"

import "./PostNowhuo.vue?vue&type=style&index=0&id=faab0d6c&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faab0d6c"]])

export default __exports__